import { style } from "styled-system";

export const fill = style({
  // React prop name
  prop: "fill",
  // The corresponding CSS property (defaults to prop argument)
  cssProperty: "fill",
  // key for theme values
  key: "fills"
});
